/**
 * @file set
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'

class Set extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    return (
      <div id="set">
        <div className="inner-title">课程类型</div>
        <div className="inner">
          <div className="set-first">
            <div className="order">1</div>
            <div className="talk">
              <div className="say">
                中文基础类
              </div>
              <div className="say-first">
                夯实基础，多维度、全方面提高孩子的中文听说读写综合能力
              </div>
            </div>
            <div className="pic-one"></div>
          </div>
          <div className="set-two">
            <div className="pic-two"></div>

            <div className="talk">
              <div className="say">
                技能训练类
              </div>
              <div className="say-first">
                通过对薄弱能力的补强，确保孩子中文学习体系的连贯性，做到循序渐进、稳中有升
              </div>
            </div>
            <div className="order">2</div>
          </div>
          <div className="set-three">
            <div className="order">3</div>
            <div className="talk">
              <div className="say">
                文化兴趣类
              </div>
              <div className="say-first">
                在基础课程之余，培养孩子对中文和中华文化的兴趣，促进语言技能与文化意识的整体发展
              </div>
            </div>
            <div className="pic-three"></div>
          </div>
        </div>
      </div>
    )
  }
}

export default Set
